import React, { useState, useEffect } from "react";
import "./ModalEdicion.css";

function ModalImpresionExpediente({
  isOpen,
  onClose,
  consultas = [],
  onImprimirCompleto,
  onImprimirConsulta,
}) {
  const [modo, setModo] = useState("menu"); // "menu" | "consulta"
  const [consultaSeleccionada, setConsultaSeleccionada] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setModo("menu");
      setConsultaSeleccionada(null);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  // 🔥 1️⃣ Quitamos la historia clínica (primer elemento)
  const consultasSeguimiento = (consultas || []).slice(1);

  // 🔥 2️⃣ Ordenamos DESC por fecha
  const consultasOrdenadas = consultasSeguimiento.sort((a, b) => {
    const fechaA = new Date(
      a?.fechaConsulta || a?.fecha_consulta || a?.creado_en
    );
    const fechaB = new Date(
      b?.fechaConsulta || b?.fecha_consulta || b?.creado_en
    );
    return fechaB - fechaA;
  });

  const formatearFecha = (consulta) => {
    const fecha =
      consulta?.fechaConsulta ||
      consulta?.fecha_consulta ||
      consulta?.creado_en;

    if (!fecha) return "Sin fecha";

    return new Date(fecha).toLocaleDateString("es-MX");
  };

  const handleImprimirConsulta = async () => {
    if (!consultaSeleccionada || loading) return;

    setLoading(true);
    await onImprimirConsulta?.(consultaSeleccionada);
    setLoading(false);
    onClose?.();
    };
  const handleImprimirCompleto = async () => {
    if (loading) return;

    setLoading(true);
    await onImprimirCompleto?.();
    setLoading(false);
    onClose?.();
    };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content modal-impresion"
        onClick={(e) => e.stopPropagation()}
      >
        {modo === "menu" && (
          <>
            <h3>¿Qué deseas exportar?</h3>

            <div
              className="modal-buttons"
              style={{ flexDirection: "column", gap: "10px" }}
            >
              <button onClick={handleImprimirCompleto} disabled={loading}>
                {loading ? "Generando documento..." : "Exportar expediente clínico completo PDF"}
              </button>

              <button onClick={() => setModo("consulta")}>
                Exportar solo una consulta de seguimiento (nota de evolucion) PDF
              </button>

              <button className="btn-cancelar" onClick={onClose}>
                Atrás
              </button>
            </div>
          </>
        )}

        {modo === "consulta" && (
          <>
            <h3>Selecciona la consulta</h3>

            {consultasOrdenadas.length === 0 ? (
              <>
              <p className="info-alert">
                No hay consultas registradas.
              </p>
              <div className="modal-buttons">
                <button onClick={() => setModo("menu")}>
                    Atrás
                </button>
                </div>
                </>
            ) : (
              <>
                <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                  {consultasOrdenadas.map((consulta, index) => (
                    <div key={consulta.id} div className="lista-consultas">
                      <label label className="consulta-item">
                        
                        {" "}
                        Consulta {consultasOrdenadas.length - index +1 } —{" "}
                        
                        {formatearFecha(consulta)} —{" "}
                        {consulta?.diagnostico || ""}
                        <input
                          type="radio"
                          name="consultaSeleccionada"
                          value={consulta.id}
                          checked={
                            consultaSeleccionada?.id === consulta.id
                          }
                          onChange={() =>
                            setConsultaSeleccionada(consulta)
                          }
                        />
                      </label>
                      
                    </div>
                  ))}
                </div>

                <div className="modal-buttons">
                  <button
                    onClick={handleImprimirConsulta}
                    disabled={!consultaSeleccionada || loading}
                  >
                    {loading ? "Generando documento..." : "Exportar consulta"}
                  </button>

                  <button onClick={() => setModo("menu")}>
                    Atrás
                  </button>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default ModalImpresionExpediente;